<template>
  <div class="row">
    <div class="col-12 g">
        <div class="card card-body">
            <h4 class="g">
                المخلفات السلوكية <button class="btn btn-primary btn-sm bbbtn" v-b-modal.add @click="saved =false;">
                    <i class="fa fa-plus"></i>
                    تسجيل مخالفة جديدة
                </button>
                &nbsp;
                <input type="text" placeholder="بحث عن طالب..." v-model="qs" @keyup="search()" class="btn-sm" style="padding: 4px; border: 1px solid #999">
                &nbsp;
                <select name="" v-model="selectedclassroom" id="" class="btn-sm" style="padding: 0px">
                    <option value="all">استعراض فصل معين</option>
                    <option v-for="c in classrooms" :key="c" :value="c">{{ c }}</option>
                </select>
                &nbsp;
                <button class="btn btn-warning btn-sm bbbtn" @click="printtable()">
                    <i class="fa fa-print"></i>
                    طباعة الجدول
                </button>
                &nbsp;
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="select_mode" :value="true">
                    طباعة التعهد جماعياً
                  </label>
                </div>
                <button v-if="select_mode" class="btn btn-success" @click="print(selected_to_print)"><i class="fa fa-print"></i> طباعة المحدد الآن</button>
            </h4>
            <div class="col-12 table-responsive" id="printtable">
                <table class="table table-hover table-bordered table-sm">
                    <thead>
                        <th>
                            الطلاب
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            المخالفة
                        </th>
                        <th>
                            الاجراء المتخذ
                        </th>
                        <th>
                            تم الارسال لولي الامر
                        </th>
                        <th class="none">
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <template  v-for="bi in bis">
                        <tr v-if="selectedclassroomvalid(bi)" :key="bi.name">
                            <td>
                                
                                <span v-for="(s, i) in bi.students.map(function(x){
                                    return x
                                })" :key="i">
                                <span v-if="!select_mode">
                                    {{ bi.students.length > 1 ? (i + 1) + '- ' : '' }} {{ s.name }} {{ bi.students.length > 0 ? '(' + s.classname + '-' + s.classroom + ')' : '' }} 
                                    <br>
                                    <button class="btn btn-sm text-primary fa fa-print btn-sm none" style="padding: 0px" title="طباعة تعهد" @click="print([{bi: bi, index: i}])"> تعهد</button>
                                    <button class="btn btn-sm text-danger fa fa-print btn-sm none" style="padding: 0px" title="طباعة استدعاء ولي امر" @click="printCall([{bi: bi, index: i}])"> استدعاء</button>
                                     <br class="none">
                                </span>

                                <div class="form-check" v-if="select_mode">
                                  <label class="form-check-label">
                                    <input type="checkbox" class="form-check-input" v-model="selected_to_print" :value="{bi: bi, index: i}">
                                    {{ bi.students.length > 1 ? (i + 1) + '- ' : '' }} {{ s.name }} {{ bi.students.length > 0 ? '(' + s.classname + '-' + s.classroom + ')' : '' }} 
                                  </label>
                                </div>
                                </span>
                            </td>
                            <td>
                                {{ bi.date.split(" ")[0] }}
                            </td>
                            <td>
                                {{ bi.bi }}
                            </td>
                            <td v-html="bi.actions.join('<br>')"></td>
                            <td>
                                <span v-if="bi.send.send != '2'" class="btn btn-sm btn-success">تم الارسال عبر {{ bi.send.method }}</span>
                                <span v-if="bi.send.send == '2'" class="btn btn-sm btn-primary">حفظ في الملف فقط</span>
                            </td>
                            <td class="none">
                                <button class="btn btn-sm btn-danger" style="border-radius: 0px" @click="current = bi; createforward.details = bi.bi; createforward.opinion = bi.actions.join('\n'); createforward = JSON.parse(JSON.stringify(createforward))"  v-b-modal.forward>
                                    <i class="fa fa-reply"></i>
                                    تحويل للوكيل
                                </button>
                                <button class="btn btn-sm btn-outline-danger fa fa-trash" style="border-radius: 0px" v-b-modal.remove title="حذف" @click="current = bi; "></button>
                            </td>
                        </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <b-modal id="remove" title="حذف المخالفة" hide-footer>
        <strong>
            <p>
                اختر مخالفة الطالب التي تريد حذفها:
            </p>
        </strong>
        <button class="btn btn-block btn-danger" @click="remove(current._id)">
            <i class="fa fa-check-square"></i>
            حذف مخالفات كل الطلاب
        </button>
        <button v-for="stu in current.students" :key="stu._id" class="btn btn-block btn-outline-danger" @click="removeSingle(current._id, stu.number)">
            <i class="fa fa-user"></i>
            {{ stu.name }}
        </button>
    </b-modal>
    <b-modal id="forward" title="تحويل المخالفة للوكيل" hide-footer size="lg">
        <div class="form-group">
            <span for="">نوع المشكلة &nbsp;</span>
            <span id="mm">
                <input type="text" v-model="createforward.type" v-if="ntype" placeholder="اكتب هنا...">
                <select class="form-controla bg-white" v-if="!ntype" @change="ccc(); createforward = JSON.parse(JSON.stringify(createforward))" v-model="createforward.type" required="">
                    <option value="تعليمية">تعليمية</option>
                    <option value="نفسية">نفسية</option>
                    <option value="اجتماعية">اجتماعية</option>
                    <option value="سلوكية">سلوكية</option>
                    <option value="">أخرى.. اكتب</option>
                </select>
            </span>
        </div>
        <div class="form-group">
        <span for="">تكرار المشكلة &nbsp;</span>
            <select class="f bg-white" v-model="createforward.repeat" id="">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
            </select>
        </div>
        <div class="form-group">
            <p for="">وصف المشكلة كاملة (اختياري)</p>
            <textarea class="form-control" v-model="createforward.details" id="" placeholder="اكتب هنا... (اختياري)" rows="3"></textarea>
        </div>
        <div class="form-group">
            <p for="">الاجراء المتخذ (اختياري)</p>
            <textarea class="form-control" v-model="createforward.opinion" id="" placeholder="اكتب هنا... (اختياري)" rows="3"></textarea>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="createforward.admin" :value="'yes'">
            تحويل للموجه مباشررة
          </label>
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" @click="forward()">
                تحويل {{ createforward.admin ? 'للموجه' : 'للوكيل' }} الآن
            </button>
        </div>
    </b-modal>
    <b-modal id="add" title="تسجيل مخالفة" hide-footer size="lg">
        <div class="g">
            اختر الطلاب <input type="text" placeholder="ابحث هنا..." v-model="q" @change="getStudents()" style="border: none; border: 1px solid #999; padding: 5px"> <button class="btn btn-sm"><i class="fa fa-search"></i> بحث</button>
        </div>
        <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 150px;">
            <div class="form-check" v-for="student in students" :key="student._id">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="selected" :value="student.number">
                {{ student.name }}
              </label>
            </div>
        </div>
       <p class="g">تم تحديد {{ selected.length }} طالب</p>
       <div class="form-group">
         <label for="">المرحلة</label>
         <select class="form-control" v-model="stage">
           <option value="1">المرحلة الابتدائية</option>
           <option value="2">المرحلتين المتوسطة والثانوية</option>
         </select>
       </div>
       <div class="form-group">
         <label for="">درجة المخالفة</label>
         <select class="form-control" v-model="level">
           <option value="1">الاولى</option>
           <option value="2">الثانية</option>
           <option value="3">الثالثة</option>
           <option value="4">الرابعة</option>
           <option value="5">الخامسة</option>
         </select>
       </div>
       <div class="form-group" v-if="manual_bi">
         <label for="">المخالفة <u><a href="javascript:;" @click="manual_bi = !manual_bi">اختر من القائمة</a></u></label>
         <input type="text"
           class="form-control" v-model="bi" placeholder="اكتب المخالفة هنا...">
       </div>
       <div class="form-group" v-if="!manual_bi">
         <label for="">المخالفة <u><a href="javascript:;" @click="manual_bi = !manual_bi">اكتب يدويا</a></u></label>
         <select class="form-control" v-if="level == '1' && stage == '1'" v-model="bi">
            <option value="عدم التقيد بالزي المدرسي.">عدم التقيد بالزي المدرسي.</option>
            <option value="التأخــر الصباحــي.">التأخــر الصباحــي.</option>
            <option value="عــدم حضــور الاصطفــاف الصباحــي في حــال كــان الطــالب متواجــداً داخــل المدرســة.">عــدم حضــور الاصطفــاف الصباحــي في حــال كــان الطــالب متواجــداً داخــل المدرســة.</option>
            <option value="التأخــر عــن الاصطفــاف الصباحــي – في حــال كــان الطــالب متواجــداً داخــل المدرســة – أو العبــث أثنــاءه.">التأخــر عــن الاصطفــاف الصباحــي – في حــال كــان الطــالب متواجــداً داخــل المدرســة – أو العبــث أثنــاءه.</option>
            <option value="التأخــر في دخــول الحصــص.">التأخــر في دخــول الحصــص.</option>
            <option value="إعاقــة ســير الحصــص الدراســية مثــل: الحديــث الجانبــي، المقاطعــة المســتمرة لغيــر الهادفــة لشــرح المعلــم ، تنــاول الأطعمــة أو المشروبات أثنــاء الدرس.">إعاقــة ســير الحصــص الدراســية مثــل: الحديــث الجانبــي، المقاطعــة المســتمرة لغيــر الهادفــة لشــرح المعلــم ، تنــاول الأطعمــة أو المشروبات أثنــاء الدرس.</option>
            <option value="النــوم داخــل الفصــل.">النــوم داخــل الفصــل.</option>
            <option value="تكــرار خــروج ودخــول الطلبــة مــن البوابــة قبل وقــت الحضــور والانصراف.">تكــرار خــروج ودخــول الطلبــة مــن البوابــة قبل وقــت الحضــور والانصراف.</option>
            <option value="التجمهــر أمــام بوابــة المدرســة.">التجمهــر أمــام بوابــة المدرســة.</option>
         </select>
         <select class="form-control" v-if="level == '1' && stage == '2'" v-model="bi">
            <option value="التأخــر الصباحــي.">التأخــر الصباحــي.</option>
            <option value="عــدم حضــور الاصطفــاف الصباحــي في حــال كــان الطــالب متواجــداً داخــل المدرســة.">عــدم حضــور الاصطفــاف الصباحــي في حــال كــان الطــالب متواجــداً داخــل المدرســة.</option>
            <option value="التأخــر عــن الاصطفــاف الصباحــي – في حــال كــان الطــالب متواجــداً داخــل المدرســة – أو العبــث أثنــاءه.">التأخــر عــن الاصطفــاف الصباحــي – في حــال كــان الطــالب متواجــداً داخــل المدرســة – أو العبــث أثنــاءه.</option>
            <option value="التأخــر في دخــول الحصــص.">التأخــر في دخــول الحصــص.</option>
            <option value="إعاقــة ســير الحصــص الدراســية مثــل: الحديــث الجانبــي، المقاطعــة المســتمرة لغيــر الهادفــة لشــرح المعلــم ، تنــاول الأطعمــة أو المشروبات أثنــاء الدرس.">إعاقــة ســير الحصــص الدراســية مثــل: الحديــث الجانبــي، المقاطعــة المســتمرة لغيــر الهادفــة لشــرح المعلــم ، تنــاول الأطعمــة أو المشروبات أثنــاء الدرس.</option>
            <option value="النــوم داخــل الفصــل.">النــوم داخــل الفصــل.</option>
            <option value="تكــرار خــروج ودخــول الطلبــة مــن البوابــة قبل وقــت الحضــور والانصراف.">تكــرار خــروج ودخــول الطلبــة مــن البوابــة قبل وقــت الحضــور والانصراف.</option>
            <option value="التجمهــر أمــام بوابــة المدرســة.">التجمهــر أمــام بوابــة المدرســة.</option>
         </select>
         <select class="form-control" v-if="level == '2' && stage == '1'" v-model="bi">
            <option value="عــدم حضــور الحصــة الدراســية أو الهــروب منهــا.">عــدم حضــور الحصــة الدراســية أو الهــروب منهــا.</option>
            <option value="الدخــول أو الخــروج مــن الفصــل دون استئذان.">الدخــول أو الخــروج مــن الفصــل دون استئذان.</option>
            <option value="دخــول فصــل آخــر دون استئذان.">دخــول فصــل آخــر دون استئذان.</option>
            <option value="إثــارة الفوضــى داخــل الفصــل أو المدرســة أو في وســائل النقــل المدرســي.">إثــارة الفوضــى داخــل الفصــل أو المدرســة أو في وســائل النقــل المدرســي.</option>

            <option value="الشجـار أو الاشتـراك في مضاربة جماعية.">الشجـار أو الاشتـراك في مضاربة جماعية.</option>
            <option value="الإشـارة بحركـات مخلة بالآداب تجاه الطلبة.">الإشـارة بحركـات مخلة بالآداب تجاه الطلبة.</option>
            <option value="التلفـظ بكلمـات نابيـة على الطلبـة أو المعلميـن أو الإداريين أو تهديدهم أو السخرية منهم.">التلفـظ بكلمـات نابيـة على الطلبـة أو المعلميـن أو الإداريين أو تهديدهم أو السخرية منهم.</option>
            <option value="إلحـاق الضـرر المتعمـد بممتلكات الطلبة.">إلحـاق الضـرر المتعمـد بممتلكات الطلبة.</option>
            <option value="العبـث بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعـدات الأمن والسلامة المدرسية، الكهربـاء، المعامل، حافلة المدرسة والكتابة على الجدار وغيره.">العبـث بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعـدات الأمن والسلامة المدرسية، الكهربـاء، المعامل، حافلة المدرسة والكتابة على الجدار وغيره.</option>
            <option value="امتهان الكتب الدراسية">امتهان الكتب الدراسية</option>

         </select>
         <select class="form-control" v-if="level == '2' && stage == '2'" v-model="bi">
            <option value="عــدم حضــور الحصــة الدراســية أو الهــروب منهــا.">عــدم حضــور الحصــة الدراســية أو الهــروب منهــا.</option>
            <option value="الدخــول أو الخــروج مــن الفصــل دون استئذان.">الدخــول أو الخــروج مــن الفصــل دون استئذان.</option>
            <option value="دخــول فصــل آخــر دون استئذان.">دخــول فصــل آخــر دون استئذان.</option>
            <option value="إثــارة الفوضــى داخــل الفصــل أو المدرســة أو في وســائل النقــل المدرســي.">إثــارة الفوضــى داخــل الفصــل أو المدرســة أو في وســائل النقــل المدرســي.</option>
         </select>
         <select class="form-control" v-if="level == '3' && stage == '1'" v-model="bi">
            <option value="التلفــظ بكلمــات نابيــة تجــاه المعلميــن/ات أو الادارييــن/ات.">التلفــظ بكلمــات نابيــة تجــاه المعلميــن/ات أو الادارييــن/ات.</option>
            <option value="إلحـاق الضـرر المتعمـد بممتلـكات المعلميـن، أو المدرسـة.">إلحـاق الضـرر المتعمـد بممتلـكات المعلميـن، أو المدرسـة.</option>
            <option value="ســرقة شــيء مــن ممتلــكات المعلميــن أو المدرســة.">ســرقة شــيء مــن ممتلــكات المعلميــن أو المدرســة.</option>
            <option value="تعمــد إتـلاف شــيء مــن تجهيــزات المدرســة أو مبانيهــا كأجهــزة الحاســوب ، أدوات ومعــدات الامــن والسلامة المدرســية، الكهربــاء، المعامــل، الحافلــة المدرســة.">تعمــد إتـلاف شــيء مــن تجهيــزات المدرســة أو مبانيهــا كأجهــزة الحاســوب ، أدوات ومعــدات الامــن والسلامة المدرســية، الكهربــاء، المعامــل، الحافلــة المدرســة.</option>
            <option value="إحضــار أو اســتخدام المــواد أو الالعـاب الخطـرة إلـى المدرسـة، مثـل الالعــاب الناريــة، البخاخــات الغازيــة الملونــة، المــواد الكيمائيــة.">إحضــار أو اســتخدام المــواد أو الالعـاب الخطـرة إلـى المدرسـة، مثـل الالعــاب الناريــة، البخاخــات الغازيــة الملونــة، المــواد الكيمائيــة.</option>
            <option value="حيــازة أو عــرض المــواد الاعلاميــة الممنوعــة المقــروءة، أو المســموعة ، أو المرئيــة .">حيــازة أو عــرض المــواد الاعلاميــة الممنوعــة المقــروءة، أو المســموعة ، أو المرئيــة .</option>
            <option value="إحضـار أجهـزة الاتصـال الشـخصية ( اياً كان نوعها )">إحضـار أجهـزة الاتصـال الشـخصية ( اياً كان نوعها )</option>
            <option value="التوقيــع عــن ولــي الامــر مــن غيــر علمـه علـى المكاتبـات المتبادلـة بيـن المدرســة وولــي الامــر.">التوقيــع عــن ولــي الامــر مــن غيــر علمـه علـى المكاتبـات المتبادلـة بيـن المدرســة وولــي الامــر.</option>
            <option value="مهاجمــة أحــد الزمــلاء بالضــرب.">مهاجمــة أحــد الزمــلاء بالضــرب.</option>
            <option value="التنمر">التنمر</option>
            <option value="الهروب من المدرسة.">الهروب من المدرسة.</option>
            <option value="التحـرش الجنسـي غيـر المباشـر">التحـرش الجنسـي غيـر المباشـر</option>
            <option value="تصويــر الطــلاب والطالبــات والمعلميــن بالأجهزة الإلكترونية أيا كان نوعهــا.">تصويــر الطــلاب والطالبــات والمعلميــن بالأجهزة الإلكترونية أيا كان نوعهــا.</option>
            <option value="امتهان الكتــب الدراســية .">امتهان الكتــب الدراســية .</option>
         </select>
         <select class="form-control" v-if="level == '3' && stage == '2'" v-model="bi">
            <option value="عــدم التقيــد بالزي المدرسي.">عــدم التقيــد بالزي المدرسي.</option>
            <option value="الشجـار أو الاشتـراك في مضاربة جماعية.">الشجـار أو الاشتـراك في مضاربة جماعية.</option>
            <option value="الإشـارة بحركـات مخلة بالآداب تجاه الطلبة.">الإشـارة بحركـات مخلة بالآداب تجاه الطلبة.</option>
            <option value="التلفـظ بكلمـات نابيـة على الطلبـة أو المعلميـن أو الإداريين أو تهديدهم أو السخرية منهم.">التلفـظ بكلمـات نابيـة على الطلبـة أو المعلميـن أو الإداريين أو تهديدهم أو السخرية منهم.</option>
            <option value="إلحـاق الضـرر المتعمـد بممتلكات الطلبة.">إلحـاق الضـرر المتعمـد بممتلكات الطلبة.</option>
            <option value="العبـث بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعـدات الأمن والسلامة المدرسية، الكهربـاء، المعامل، حافلة المدرسة والكتابة على الجدار وغيره.">العبـث بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعـدات الأمن والسلامة المدرسية، الكهربـاء، المعامل، حافلة المدرسة والكتابة على الجدار وغيره.</option>
            <option value="إحضار المواد أو الألعاب الخطرة إلى المدرسة دون استخدامها، وذلك مثل: (الألعاب النارية، البخاخات الغازية الملونة، المواد الكيمائية).">إحضار المواد أو الألعاب الخطرة إلى المدرسة دون استخدامها، وذلك مثل: (الألعاب النارية، البخاخات الغازية الملونة، المواد الكيمائية).</option>
            <option value="حيازة السجائر بأنواعها.">حيازة السجائر بأنواعها.</option>
            <option value="حيازة المواد الإعلامية الممنوعة المقروءة أو المسموعة أو المرئية.">حيازة المواد الإعلامية الممنوعة المقروءة أو المسموعة أو المرئية.</option>
            <option value="التوقيع عن ولي الأمر من غير علمه على المكاتبات المتبادلة بين المدرسة وولي الأمر.">التوقيع عن ولي الأمر من غير علمه على المكاتبات المتبادلة بين المدرسة وولي الأمر.</option>
            <option value="امتهان الكتب الدراسية.">امتهان الكتب الدراسية.</option>
         </select>
         <select class="form-control" v-if="level == '4' && stage == '1'" v-model="bi">
            <option value="التحرش المباشر">التحرش المباشر</option>
            <option value="إشعال النار داخل المدرسة.">إشعال النار داخل المدرسة.</option>
            <option value="حيــازة الســجائر أو ا لتد خيــن .">حيــازة الســجائر أو ا لتد خيــن .</option>
            <option value=".إحضــار آلــة حــادة للمدرسـة بقصـد التهديـد أو الاعتداء.">.إحضــار آلــة حــادة للمدرسـة بقصـد التهديـد أو الاعتداء.</option>
         </select>
         <select class="form-control" v-if="level == '4' && stage == '2'" v-model="bi">
            <option value="تعمّد إصابة أحد الطلبة عن طريق الضرب باليد أو استخدام أدوات غير حادة تحدث إصابة (جرحاً أو نزفاً أو كسراً).">تعمّد إصابة أحد الطلبة عن طريق الضرب باليد أو استخدام أدوات غير حادة تحدث إصابة (جرحاً أو نزفاً أو كسراً).</option>
            <option value="سرقة شيء من ممتلكات الطلبة أو المدرسة.">سرقة شيء من ممتلكات الطلبة أو المدرسة.</option>
            <option value="التصوير أو التسجيل الصوتي للطلبة.">التصوير أو التسجيل الصوتي للطلبة.</option>
            <option value="إلحاق الضرر المتعمّد بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعدات الأمن والسلامة المدرسية، الكهرباء، المعامل، حافلة المدرسة).">إلحاق الضرر المتعمّد بتجهيزات المدرسة أو مبانيها (كأجهزة الحاسوب، أدوات ومعدات الأمن والسلامة المدرسية، الكهرباء، المعامل، حافلة المدرسة).</option>
            <option value="التدخين بأنواعه داخل المدرسة.">التدخين بأنواعه داخل المدرسة.</option>
            <option value="الهروب من المدرسة.">الهروب من المدرسة.</option>
            <option value="إحضار أو استخدام المواد أو الألعاب الخطرة إلى المدرسة مثل: الألعاب النارية، البخاخات الغازية الملونة، المواد الكيمائية.">إحضار أو استخدام المواد أو الألعاب الخطرة إلى المدرسة مثل: الألعاب النارية، البخاخات الغازية الملونة، المواد الكيمائية.</option>
            <option value="عرض أو توزيع المواد الإعلامية الممنوعة المقروءة أو المسموعة أو المرئية.">عرض أو توزيع المواد الإعلامية الممنوعة المقروءة أو المسموعة أو المرئية.</option>
         </select>
         <select class="form-control" v-if="level == '5' && stage == '2'" v-model="bi">
            <option value="الإساءة أو الاستهزاء بشيء من شعائر الإسلام.">الإساءة أو الاستهزاء بشيء من شعائر الإسلام.</option>
            <option value="الإساءة للدولة ورموزها.">الإساءة للدولة ورموزها.</option>
            <option value="بث أو ترويج أفكار ومعتقدات متطرفة أو تكفيرية أو إلحادية مسيئة لنظم المجتمع السياسية والاجتماعية.">بث أو ترويج أفكار ومعتقدات متطرفة أو تكفيرية أو إلحادية مسيئة لنظم المجتمع السياسية والاجتماعية.</option>
            <option value="الإساءة إلى الأديان السماوية أو بث ما يسبب الفتنة الطائفية أو المذهبية.">الإساءة إلى الأديان السماوية أو بث ما يسبب الفتنة الطائفية أو المذهبية.</option>
            <option value="التزوير أو الاستخدام أو الاستفادة من الوثائق أو الأختام الرسمية بطريقة غير مشروعة نظاماً.">التزوير أو الاستخدام أو الاستفادة من الوثائق أو الأختام الرسمية بطريقة غير مشروعة نظاماً.</option>
            <option value="التحرش الجنسي.">التحرش الجنسي.</option>
            <option value="المظاهر أو الصور أو الشعارات التي تدل على الشذوذ الجنسي أو الترويج لها.">المظاهر أو الصور أو الشعارات التي تدل على الشذوذ الجنسي أو الترويج لها.</option>
            <option value="إشعال النار داخل المدرسة.">إشعال النار داخل المدرسة.</option>
            <option value="حيازة أو استخدام أو تهديد الطلبة بالأسلحة النارية أو ما في حكمها مثل: السكاكين والأدوات الحادة والرصاص بدون مسدس.">حيازة أو استخدام أو تهديد الطلبة بالأسلحة النارية أو ما في حكمها مثل: السكاكين والأدوات الحادة والرصاص بدون مسدس.</option>
            <option value="حيازة أو تعاطي أو ترويج المخدرات أو المسكرات.">حيازة أو تعاطي أو ترويج المخدرات أو المسكرات.</option>
            <option value="الجرائم المعلوماتية بكافة أنواعها.">الجرائم المعلوماتية بكافة أنواعها.</option>
            <option value="ابتزاز الطلبة.">ابتزاز الطلبة.</option>
            <option value="التنمر بجميع أنواعه وأشكاله.">التنمر بجميع أنواعه وأشكاله.</option>
         </select>
       </div>
       <div class="form-group" v-if="actions && actions['1-1']">
         <label for="">الاجراء المتخذ</label>
         <div class="col-12 g" style="border: solid 2px; overflow-y: auto; height: 200px">
            <template v-for="actiona in actions[stage+'-'+level]">
            <span v-if="actiona.includes('--')" :key="actiona">
                # {{ actiona }}
            </span>
            <div class="form-check"  v-if="!actiona.includes('--')" :key="actiona">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="action" :value="actiona">
                {{ actiona }}
              </label>
            </div>
            </template>
         </div>
       </div>
       <div class="row">
        <div class="col-12 col-lg-4 g">
            <button class="btn btn-success btn-block" @click="send=1;done()">
                <i class="fa fa-paper-plane"></i>
                ارسال لولي الامر فقط
            </button>
        </div>
        <div class="col-12 col-lg-4 g">
            <button class="btn btn-primary btn-block" @click="send=2;done()">
                <i class="fa fa-save"></i>
                حفظ في ملف الطالب
            </button>
        </div>
        <div class="col-12 col-lg-4 g">
            <button class="btn btn-danger btn-block" @click="send=3;done()">
                <i class="fa fa-save"></i>
                <i class="fa fa-paper-plane"></i>
                ارسال وحفظ
            </button>
        </div>
       </div>
    </b-modal>
    <b-modal id="send" title="رسالة ولي الامر" hide-footer size="sm">
        <div class="form-group">
          <label for="">رسالة ولي الامر</label>
          <textarea class="form-control" v-model="message" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label for="">ارسال عبر</label>
          <select class="form-control" v-model="sendmethod">
            <option value="whatsapp">الواتس الذكي</option>
            <option value="sms">الرسائل النصية SMS</option>
          </select>
        </div>
        <div class="alert text-center border g">
            <span v-if="sendmethod == 'whatsapp'">
                يمكنك التأكد من ربط الواتس اب <a href="/_whatsapp" target="_blank">من هنا</a>
            </span>
            <span v-if="sendmethod == 'sms'">
                يمكنك التأكد من اعدادات الـSMS <a href="/sms" target="_blank">من هنا</a>
            </span>
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-primary" @click="method=true;done()">
                ارسال الآن
            </button>
            <br><br>
            *تأكد من اعدادات الارسال من صفحة الاعدادات
        </div>
        <hr>
    <div class="col-12 text-center">
        - او -
    </div>
        <hr>
        <button class="btn btn-block btn-success" @click="sendmethod='wa';wa=true;done()">
            <i class="fa fa-whatsapp"></i>
            ارسال عبر اداة المتصفح
        </button>
    </b-modal>
    <button class="dnone" id="sssend" v-b-modal.send></button>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            date: new Date().toISOString().split("T")[0],
            bis: [],
            students: [],
            current: {},
            createforward: {},
            wa: false,
            saved: false,
            info: {},
            selected: [],
            q: null,
            user: JSON.parse(localStorage.getItem('user')),
            level: 1,
            stage: 1,
            bi: "",
            action: [],
            manual_bi: false,
            classrooms: [],
            selectedclassroom: 'all',
            qs: "",
            send: null,
            method: null,
            sendmethod: "whatsapp",
            select_mode: false,
            original_bis: [],
            selected_to_print: [],
            message: `تم تسجيل مخالفة سلوكية على ابنكم {name}\nالمخالفة: {bi}\الاجراء المتخذ: {action}`,
            // actions: [
            //     "إشعار ولي الأمر بالمخالفة والإجراءات المتخذه",
            //     "أخذ تعهد خطي على الطالب",
            //     "إعتذار الطالب عن ما بدر منه",
            //     "إصلاح ما أتلفه الطالب",
            //     "مصادرة المواد الممنوعة التي أحضرها",
            //     "نقل الطالب المصاب للمركز الصحي",
            //     "حسم درجة من درجات السلوك",
            //     "حسم درجتان من درجات السلوك",
            //     "حسم ثلاث درجات من درجات السلوك",
            //     "حسم عشر درجات من درجات السلوك",
            //     "حسم خمس عشر درجة من درجات السلوك",
            //     "الإحالة للموجه الطلابي لدراسة حالته متمكينه من تعويض الدرجات",
            //     "استدعاء ولي الأمر وتوقيعه بالعلم على المشكلة والإجراءات المتخذة",
            //     "نقل الطالب إلى فصل آخر",
            //     "الإحالة إلى لجنة التوجيه الطلابي للمساعدة في علاج وضع الطالب وفقا لتقرير الموجه الطلابي",
            //     "إنذار بالنقل لمدرسة أخرى في حال تكرار المخالفة",
            //     "الإحالة  لإدارة / قسـم التوجيـه الطلابــي",
            //     "الرفع لإدارة التعليم بالنقل لمدرسة أخرى",
            //     "إشعار ولي الأمر لأخذ رأيه في المدرسة التي سينقل ابنه إليها"
            // ],
            actions: {
                "1-1": [
  "-- الاجراء الاول --",              
  "التنبيه الشفهي الأول من المعلم أو إدارة المدرسة للطالب عن السلوك والأضرار المترتبة عليه، وكونه سلوكاً غير مرغوباً به وذلك بأسلوب تربوي حكيم.",
 
  "-- الاجراء الثاني --",
 "التنبيه الشفهي الثاني من المعلم أو إدارة المدرسة عند مباشرة الموقف بأسلوب تربوي حكيم، وتعزيز السلوك الإيجابي.",
  "ملاحظة الطالب وحصر السلوكيات السلبية والإيجابية، ومسببات حدوثها، والبدء بالحد من مسببات السلوك السلبي، وتعزيز السلوك الإيجابي.",
  
  "-- الاجراء الثالث --",
  "تدوين المشكلة السلوكية من المعلم المباشر للموقف في سجل المشكلات السلوكية وتوقيع الطالب عليها.",
  "إشعار ولي أمر الطالب هاتفياً بمشكلة الطالب السلوكية.",
  "حسم درجة من درجات السلوك الإيجابي للطالب من قبل إدارة المدرسة، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "بعد تنفيذ الإجراء؛ تحويل الطالب إلى الموجه الطلابي لدراسة حالته.",
  
  "-- الاجراء الرابع --",
  "دعوة ولي أمر الطالب وإخطاره بسلوك الطالب غير المرغوب فيه ، والاتفاق على خطة لتعديل السلوك بين الأسرة والمدرسة يقوم بها الموجه الطلابي.",
  "حسم درجة من درجات السلوك الإيجابي للطالب مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "تحويل الطالب إلى لجنة التوجيه الطلابي في المدرسة لبحث أسباب عدم استجابة الطالب لإجراءات تعديل السلوك، وإيجاد الحلول المناسبة للمشكلات السلوكية وفق تقرير دراسة الحالة من الموجه الطلابي في المدرسة.",
  "متابعة حالة الطالب من قبل الموجه الطلابي لتقديم الخدمات التربوية."],
                "1-2": [
                    
  "-- الاجراء الاول --",
"إشعار ولي الأمر هاتفياً بمشكلة الطالب السلوكية والإجراءات المتخذة.",
  "حسم درجتين من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "الاعتذار إلى من أساء إليهم.",
  "إصلاح ما أتلفه الطالب أو إحضار بديل عنه.",
  "إحالة الطالب للموجه الطلابي لدراسة حالته.",

  "-- الاجراء الثاني --",
  "جميع ما ذكر في الإجراء الأول مع تغيير إجراءات خطة تعديل السلوك.",
  "دعوة ولي أمر الطالب، ومناقشته في خطة تعديل السلوك، ووضع برنامج وقائي مشترك مع الأسرة وأخذ تعهد خطي على الطالب بعدم تكرار السلوك غير المرغوب فيه، وتوقيع ولي الأمر بالعلم.",
  "متابعة حالة الطالب من قبل الموجه الطلابي لتقديم الخدمات التربوية.",

  "-- الاجراء الثالث --",
  "جميع ما ذكر في الإجراء الثاني مع تغيير إجراءات خطة تعديل السلوك.",
  "تحويل الطالب إلى لجنة التوجيه الطلابي في المدرسة لبحث أسباب عدم استجابة الطالب لإجراءات تعديل السلوك، وإيجاد الحلول المناسبة للمشكلات السلوكية وفق تقرير دراسة الحالة من الموجه الطلابي في المدرسة.",
  "نقل الطالب إلى فصل آخر وفقاً لقرار لجنة التوجيه الطلابي في المدرسة."],
                "1-3": [
                    
  "-- الاجراء الاول --",
  "دعوة ولي أمر الطالب، ومناقشته في خطة تعديل السلوك ووضع برنامج وقائي مشترك مع الأسرة، وأخذ تعهد خطي على الطالب بعدم تكرار السلوك غير المرغوب فيه ، وتوقيع ولي الأمر بالعلم.",
  "حسم ثلاث درجات من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "الاعتذار إلى من أساء إليهم.",
  "إصلاح ما أتلفه الطالب أو إحضار بديل عنه.",
  "مصادرة ما بحوزة الطالب من مواد ممنوعة وإتلافها من قبل لجنة التوجيه الطلابي في المدرسة وذلك فيما لم يرد فيه نص نظامي وإعداد محضر بذلك.",
  "إحالة الطالب إلى الموجه الطلابي لدراسة حالته.",
   
  "-- الاجراء الثاني --",
  "جميع ما ذكر في الإجراء الأول مع تغيير إجراءات خطة تعديل السلوك.",
  "نقل الطالب إلى فصل آخر وفقاً لقرار لجنة التوجيه الطلابي.",
  "متابعة حالة الطالب من قبل الموجه الطلابي لتقديم الخدمات التربوية.",

  "-- الاجراء الثالث --",
  "جميع ما ذكر في الإجراء الثاني، مع تغيير إجراءات خطة تعديل السلوك.",
  "ترفع إدارة المدرسة رسمياً وبصفة عاجلة لإدارة التعليم محضر اجتماع لجنة التوجيه في المدرسة بخصوص القضية.",
  "يصدر مدير التعليم قراراً بنقل الطالب إلى مدرسة أخرى، مع استمراره بالدراسة حتى النقل، ومع الأخذ برأي ولي الأمر في المدرسة التي سينقل إليها الطالب (وفي حال عدم موافقة ولي الأمر على المدرسة ينقل الطالب إلى أقرب مدرسة لمقر سكنه).",
  "إحالة الحالة للموجه الطلابي في المدرسة المنقول إليها الطالب لتقديم برنامج تربوي يشتمل على جلسات في تعديل السلوك.",
  "يُكتب تعهد خطي من قبل الطالب وبحضور ولي الأمر بالالتزام بالانضباط والسلوك الحسن بعد استكمال البرنامج التربوي من قبل الموجه الطلابي.",
  "متابعة الحالة من الموجه الطلابي في المدرسة المنقول إليها الطالب لتقديم الخدمات التربوية."
],
                "1-4": [
  "دعوة ولي أمر الطالب، وتوضيح الإجراءات المترتبة على هذا السلوك، ومناقشته في خطة تعديل السلوك، ووضع برنامج وقائي مشترك مع الأسرة، وأخذ تعهد خطي على الطالب بعدم تكرار السلوك غير المرغوب فيه وتوقيع ولي الأمر بالعلم.",
  "حسم عشر درجات من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "الاعتذار إلى من أساء إليهم.",
  "تحويل الطالب إلى الموجه الطلابي لدراسة حالته.",
  "ترفع إدارة المدرسة رسمياً وبصفة عاجلة لإدارة التعليم محضر اجتماع لجنة التوجيه في المدرسة بخصوص القضية.",
  "يصدر مدير التعليم قراراً بنقل الطالب إلى مدرسة أخرى، مع استمراره بالدراسة حتى النقل، ومع الأخذ برأي ولي الأمر في المدرسة التي سينقل إليها الطالب (وفي حال عدم موافقة ولي الأمر على المدرسة يتم نقل الطالب إلى أقرب مدرسة لمقر سكنه).",
  "إحالة الحالة للموجه الطلابي في المدرسة المنقول إليها الطالب لتقديم برنامج تربوي يشتمل على جلسات في تعديل السلوك.",
  "يُكتب تعهد خطي من قبل الطالب وبحضور ولي الأمر بالالتزام بالانضباط، والسلوك الحسن بعد استكمال البرنامج التربوي من قبل الموجه الطلابي.",
  "متابعة الحالة من الموجه الطلابي في المدرسة المنقول إليها الطالب لتقديم الخدمات التربوية."
],
                "2-1": [

  "-- الاجراء الاول --",
  "التنبيه الشفهي الأول من المعلم أو إدارة المدرسة للطالب عن السلوك وأضراره المترتبة، وكونه يعد سلوكاً غير مرغوب بأسلوب تربوي حكيم.",
  
  "-- الاجراء الثاني --",
  "التنبيه الشفهي الثاني من المعلم، أو إدارة المدرسة عند مباشرة الموقف بأسلوب تربوي حكيم، وتعزيز السلوك الإيجابي.",
  "ملاحظة الطالب وحصر السلوكيات السلبية والإيجابية، ومسببات حدوثها، والبدء بالحد من مسببات السلوك السلبي، وتعزيز السلوك الإيجابي.",
 
  "-- الاجراء الثالث --",
 "تدوين المشكلة السلوكية من المعلم المباشر للموقف، وتوقيع الطالب عليها.",
  "إشعار ولي أمر الطالب هاتفياً بمشكلة الطالب السلوكية، والتنسيق معه لتعديل السلوك المخالف.",
  "حسم درجة من درجات السلوك الإيجابي للطالب من قبل إدارة المدرسة، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "تحويل الطالب إلى الموجه الطلابي لدراسة حالته.",

  "-- الاجراء الرابع --",
  "دعوة ولي أمر الطالب وإخطاره بسلوك الطالب غير المرغوب فيه ، والاتفاق على خطة لتعديل السلوك بين الأسرة والمدرسة يقوم بها الموجه الطلابي.",
  "حسم درجة من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "تحويل الطالب إلى لجنة التوجيه الطلابي في المدرسة لبحث أسباب عدم استجابة الطالب لإجراءات تعديل السلوك، وإيجاد الحلول المناسبة للمشكلات السلوكية وفق تقرير دراسة الحالة من الموجه الطلابي في المدرسة.",
  "يتابع الموجه الطلابي حالته لتقديم الخدمات التربوية."
],
                "2-2": [

  "-- الاجراء الاول --",
  "إشعار ولي الأمر هاتفياً بمشكلة الطالب السلوكية والإجراءات المتخذة.",
  "حسم درجتين من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض لتعديل سلوكه ولتعويض الدرجات المحسومة، وإشعار ولي الأمر بذلك.",
  "أخذ تعهد خطي على الطالب بعدم تكرار المخالفة.",
  "تحويل الطالب إلى الموجه الطلابي لدراسة حالته.",

  "-- الاجراء الثاني --",
  "جميع ما ذكر في الإجراء الأول.",
  "دعوة ولي أمر الطالب حضورياً، ومناقشته في خطة تعديل السلوك، ووضع برنامج وقائي مشترك مع الأسرة، وتوقيع ولي الأمر بالعلم.",
  "متابعة حالة الطالب من قبل الموجه الطلابي لتقديم الخدمات التربوية.",

  "-- الاجراء الثالث --",
  "تنفيذ جميع ما ذكر في الإجراء الثاني.",
  "نقل الطالب إلى فصل آخر وفقاً لقرار لجنة التوجيه الطلابي في المدرسة.",
  "تحويل الطالب المخالف إلى لجنة التوجيه الطلابي في المدرسة لوضع الحلول المناسبة لمخالفته، وفقاً لتقرير دراسة الحالة من الموجه الطلابي في المدرسة."
],
                "2-3": [

  "-- الاجراء الاول --",
  "دعوة ولي أمر الطالب، وتوضيح الإجراءات المترتبة على هذا السلوك في حال تكراره، ومناقشته في خطة تعديل السلوك، ووضع برنامج وقائي مشترك مع الأسرة، وأخذ تعهد خطي على الطالب بعدم تكرار السلوك غير المرغوب فيه وتوقيع ولي الأمر بالعلم.",
  "حسم ثلاث درجات من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض وإشعار ولي الأمر بذلك.",
  "الاعتذار إلى من أساء إليهم.",
  "إصلاح ما أتلفه الطالب، أو إحضار بديل عنه.",
  "مصادرة ما بحوزة الطالب من مواد ممنوعة وإتلافها من قبل لجنة التوجيه الطلابي في المدرسة وذلك فيما لم يرد فيه نص نظامي وإعداد محضر بذلك.",
  "تحويل الطالب إلى الموجه الطلابي لدراسة حالته.",

  "-- الاجراء الثاني --",
  "تنفيذ جميع ما ورد في الإجراء الأول.",
  "دعوة ولي أمر الطالب، وإنذار الطالب كتابياً بالنقل إلى مدرسة أخرى في حال تكرار المخالفة، وتوقيع ولي الأمر بالعلم بذلك.",
  "تحويل الحالة إلى لجنة التوجيه الطلابي في المدرسة لوضع الحلول المناسبة لمخالفته وفقاً لتقرير دراسة الحالة من الموجه الطلابي في المدرسة.",
  "نقل الطالب المخالف سلوكياً إلى فصل آخر وفقاً لقرار لجنة التوجيه الطلابي في المدرسة.",
  "متابعة حالة الطالب من قبل الموجه الطلابي لتقديم الخدمات التربوية.",

  "-- الاجراء الثالث --",
  "تنفيذ جميع ما ورد في الإجراء الأول.",
  "ترفع إدارة المدرسة رسمياً وبصفة عاجلة لإدارة التعليم محضر اجتماع لجنة التوجيه في المدرسة بخصوص القضية.",
  "يصدر مدير التعليم قراراً بنقل الطالب إلى مدرسة أخرى (الصفين الثاني والثالث الثانوي يتم التعامل معهم وفق نظام المسارات) مع استمراره بالدراسة حتى النقل، مع الأخذ برأي ولي الأمر في المدرسة التي سينقل إليها الطالب (وفي حال عدم موافقة ولي الأمر على المدرسة يتم نقل الطالب إلى أقرب مدرسة لمقر سكنه).",
  "متابعة الحالة من الموجه الطلابي في المدرسة المنقول إليها الطالب لتقديم الخدمات التربوية."
],
                "2-4": [

  "-- الاجراء الاول --",
  "دعوة ولي أمر الطالب، وتوضيح الإجراءات المترتبة على هذا السلوك في حال تكراره، ومناقشته خطة تعديل السلوك، ووضع برنامج وقائي مشترك مع الأسرة، وأخذ تعهد خطي على الطالب بعدم تكرار السلوك غير المرغوب فيه، وإنذاره بالنقل إلى مدرسة أخرى في حالة إعادة تكرار المشكلة، وتوقيع ولي الأمر بالعلم.",
  "حسم عشر درجات من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض، وإشعار ولي الأمر بذلك.",
  "تقديم الاعتذار لمن أسيء إليهم.",
  "إصلاح ما أتلفه الطالب أو إحضار بديل عنه، وإشعار ولي أمره بذلك.",
  "مصادرة ما بحوزة الطالب من مواد ممنوعة، وإتلافها (وذلك فيما لم يرد فيه نص نظامي)، وإعداد محضر بذلك من قبل لجنة التوجيه الطلابي في المدرسة.",
  "نقل الطالب من فصل إلى آخر وفقاً لقرار لجنة التوجيه الطلابي في المدرسة.",
  "متابعة الحالة من الموجه الطلابي، وتقديم الخدمات التربوية.",

  "-- الاجراء الثاني --",
  "تنفيذ جميع ما ورد في الإجراء الأول، باستثناء نقل الطالب من الفصل.",
  "رفع محضر اجتماع لجنة التوجيه في المدرسة إلى إدارة التعليم رسمياً وبصفة عاجلة بخصوص القضية.",
  "إصدار قرار من مدير التعليم بنقل الطالب إلى مدرسة أخرى (الصفين الثاني والثالث الثانوي يتم التعامل معهم وفق نظام المسارات)، مع استمراره بالدراسة حتى النقل، وأخذ رأي ولي الأمر في المدرسة التي سينقل إليها الطالب (وفي حال عدم موافقة ولي الأمر على المدرسة، يتم نقل الطالب إلى أقرب مدرسة لمقر سكنه).",
  "تمكين الطالب من فرص التعويض لتعديل سلوكه وتعويض الدرجات المحسومة في المدرسة المنقول إليها، وإشعار ولي أمره بذلك.",
  "متابعة الحالة من الموجه الطلابي في المدرسة المنقول إليها الطالب، وتقديم الخدمات التربوية."
],
                "2-5": [
  "تُدوّن إدارة المدرسة محضراً لإثبات الواقعة.",
  "دعوة ولي أمر الطالب، وتبليغه بمشكلة الطالب والإجراءات المترتبة على ذلك.",
  "حسم خمس عشرة درجة من درجات السلوك الإيجابي للطالب، مع تمكينه من فرص التعويض لتعديل سلوكه وتعويض الدرجات المحسومة في المدرسة المنقول إليها، وإشعار ولي أمره بذلك.",
  "اجتماع لجنة التوجيه الطلابي في المدرسة بعد وقوع القضية مباشرة لدراسة ظروفها وملابساتها.",
  "متابعة الحالة من الموجه الطلابي وتقديم الخدمات التربوية.",
  "رفع محضر اجتماع لجنة التوجيه الطلابي في المدرسة بخصوص القضية إلى إدارة التعليم رسمياً وبصفة عاجلة.",
  "إصدار قرار من مدير التعليم بنقل الطالب إلى مدرسة أخرى (الصفين الثاني والثالث الثانوي يتم التعامل معهم وفق نظام المسارات)، مع استمراره بالدراسة حتى النقل، وأخذ رأي ولي الأمر في المدرسة التي سينقل إليها الطالب (وفي حال عدم موافقة ولي الأمر على المدرسة يتم نقل الطالب إلى أقرب مدرسة لمقر سكنه).",
  "متابعة الحالة من الموجه الطلابي في المدرسة المنقول إليها الطالب، وتقديم الخدمات التربوية."
],
            },
            studentsObj: {},
            ntype: false
        }
    },
    created(){
        if(!checkPer("students|bis")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getStudents()
        g.getReport()
        $.post(api + '/user/teachers/info', {
            jwt: g.user.jwt
        }).then(function(r){
            g.info = r.response
        })
        if(window.location.hash){
            setTimeout(function(){
                $(".bbbtn").click()
                g.selected = [window.location.hash.replace("#", '')]
            }, 500)
        }
    },
    methods: {
        printtable(){
            var g = this;
            var win = window.open(``);
            win.document.write(`
            <html dir='rtl'>
                <head>
                    <style>
                        table th, table td
                        {
                            border: 1px solid #ccc;
                        }
                        table, td, th {
                        border: 1px solid;
                        padding: 0px;
                        }

                        table {
                        width: 100%;
                        border-collapse: collapse;
                        }
                        .none{
                            display: none
                        }
                    </style>
                </head>
                <body>
                ${$("#printtable").html()}
                </body>
            </html>
            
            `)
            win.document.close();
            setTimeout(() => {
                win.print();
            }, 1000);

        },
        search(){
            var g = this;
            g.bis = g.original_bis.filter(function(a){
                if(g.qs == "" || !g.qs || g.qs == " "){
                    return a;
                }else{
                    var add = false;
                    a.students.forEach(function(b){
                        if(b?.name?.includes(g.qs)){
                            add = true;
                        }
                    })
                    if(add){
                        return a;
                    }else{
                        return false;
                    }
                }
            })
        },
        selectedclassroomvalid(bi){
            var g = this;
            var re = false;
            bi.students.forEach(function(a){
                if(g.selectedclassroom == 'all' || g.selectedclassroom == a.classname + ' - ' + a.classroom){
                    re = true;
                }
            })
            return re;
        },
        forward(){
            var g = this;
            $.post(api + '/user/students/bis/forward', {
                jwt: this.user.jwt,
                type: this.createforward.type,
                opinion: this.createforward.opinion,
                details: this.createforward.details,
                students: this.current.students.map(function(x){return x.number}),
                repeat: this.createforward.repeat,
                admin: this.createforward.admin == 'yes' || this.createforward.admin == true ? 'yes' : 'no'
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    $("#forward___BV_modal_header_ > button").click();
                    alert("تم تحويل بنجاح", 100)
                    g.getReport()
                }
            }).fail(function(){
            })
        },
        ccc(){
            if(this.createforward.type == ""){
                this.ntype = true;
            }
        },
        print(arr){
        var g = this;
        var html = "";
        var win = window.open("");
        arr.forEach(function(bi){
        var index = bi.index, bi = bi.bi;
        html = html + (`
            <div class='container-fluid'>
            <div class="row" style='padding-top: 10px'>
                <div class="col-4 text-center">
                <p>
                    المملكة العربية السعودية
                    <br>
                    وزارة التعليم
                </p>
                </div>
                <div class="col-4 text-center">
                <img style="width: 150px !important;" src="https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg">
                </div>
                <div class="col-4 text-center">
                <p style='padding-top: 5px'>
                المدرسة: ${g.user.name}
                <br>
                التاريخ: ${convertToHijri(new Date().toISOString().split("T")[0])} هـ
                </p>
                </div>
                <div class='col-12 text-center'>
                <h4>تعـــهد</h4>
                </div>
                <div class='col-12'>
                    <div style='border: solid 2px black; padding: 10px'>
                        انا الطالب /ة : ${bi.students[index]?.name} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        بـ ${bi.students[index]?.classname} - ${bi.students[index]?.classroom}
                        <br>
                        <p>
                            أقر بأنني ارتكبت في تاريخ: ${g.dayname(bi.date.split(" ")[0])} الموافق ${convertToHijri(bi.date.split(" ")[0])} هـ مخالفة سلوكية ${bi.level ? 'من الدرجة ' + bi.level : ''}<br>
                            وهي: ${bi.bi}
                            <br>
                            <br>
                            وأتعهد بعدم تكرار أي مخالفة سلوكية مستقبلاً.
                            <br>
                            وعلى ذلك جرى التوقيع
                            <br>
                            <div class='row'>
                                <div class='col-6'><h5>
                            اسم الطالب/ة </h5>
                                    الاسم : ................................................................
                                        <br>
                                        التوقيع      : ................................................................
                                        <br>
                                        التاريخ      : ................................................................
                                </div>
                                <div class='col-6'><h5>
                            وكيل المدرسة: </h5>
                                    الاسم : ................................................................
                                        <br>
                                        التوقيع      : ................................................................
                                        <br>
                                        التاريخ      : ................................................................
                                </div>
                            </div>
                        </p>
                    </div>
                </div>
                <div class='col-12'><br><br>
                    <div style='border: solid 2px black; padding: 10px'>
                        انا ولي أمر الطالب /ة : ${bi.students[index]?.name} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        بـ ${bi.students[index]?.classname}
                        <br>
                        <p>
                            أبلغت بمخالفة ابني / ابنتي المتمثلة في:<br>
                            وهي: ${bi.bi}
                            <br><br>
                            وسأقوم بالتعاون مع المدرسة في تعديل سلوكه/سلوكها بما يحقق المصلحة العامة
                            <br>
                            وعلى ذلك جرى التوقيع<br><br>
                            <div class='row'>
                                <div class='col-6'><h5>
                ولي الأمر:</h5>
                                    الاسم : ................................................................
                                        <br>
                                        التوقيع      : ................................................................
                                        <br>
                                        التاريخ      : ................................................................
                                </div>
                                <div class='col-6'><h5>
                            مدير المدرسة: </h5>
                                    الاسم : ................................................................
                                        <br>
                                        التوقيع      : ................................................................
                                        <br>
                                        التاريخ      : ................................................................
                                </div>
                            </div>
                        </p>
                    </div>
                </div>
                <div class='col-12 text-center'>
                </div>
            </div>
            </div>
        `)
            
        })
        win.document.write(`
        <html dir="rtl">
            <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">
            <style>
                .bg-dark{
                background: #DDDDDD !important
                }
                        .container{
                        page-break-after:always;
                        }
            </style>
            </head>
            <body>
            ${html}
            </body>
        </html>
        `)
        win.document.close()
        setTimeout(() => {
            win.print()
        }, 1000);
        },
        printCall(arr){
        var g = this;
        var html = "";
        var win = window.open("");
        arr.forEach(function(bi){
        var index = bi.index, bi = bi.bi;
        html = html + (`
            <div class='container-fluid'>
            <div class="row" style='padding-top: 10px'>
                <div class="col-4 text-center">
                <p>
                    المملكة العربية السعودية
                    <br>
                    وزارة التعليم
                </p>
                </div>
                <div class="col-4 text-center">
                <img style="width: 150px !important;" src="https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg">
                </div>
                <div class="col-4 text-center">
                <p style='padding-top: 5px'>
                المدرسة: ${g.user.name}
                </p>
                </div>
                <div class='col-12 text-center'>
                <h4>استدعاء ولي امر</h4>
                </div>
                <div class='col-12'>
                    <div style='border: solid 2px black; padding: 10px'>
                        المكرم ولي امر الطالب /ة : ${bi.students[index]?.name} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; بالصف
                        بـ ${bi.students[index]?.classname}
                        <br><br>
                        <p>
                           السلام عليكم ورحمة الله وبركاته ،،،
                           <br><br>
                           نظراً لاهمية التعاون المستمر والتنسيق بين المدرسة وولي امر الطالب فيما يخدم مصلحته ويحقق له النجاح بإذن الله.
                           <br><br>
                           لذا نأمل منكم الحضور يوم ( &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                           الموافق  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 144  &nbsp;&nbsp;&nbsp;&nbsp;
                           الساعة ( &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; )
                        </p>
                        <center>
                            <p>
                            لمناقشة وبحث مشكلة ابنكم وهي:
                            <br>
                            <br>

                            </p>
                        </center>
                    </div>
                </div>
                <div class='col-12' style='padding: 10px'></div>
                <div class='col-6 text-center'>
                    توقيت الطباعة<br>
                    ${new Date().toISOString().replace("T", " ").split(".")[0]}
                </div>
                <div class='col-6 text-center'>
                    وكيل المدرسة<br>...........
                </div>
            </div>
            </div>
        `)
            
        })
        win.document.write(`
        <html dir="rtl">
            <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">
            <style>
                .bg-dark{
                background: #DDDDDD !important
                }
                        .container{
                        page-break-after:always;
                        }
                        @media print {
                        .print{display:none}}
            </style>
            </head>
            <body>
            <button onclick='window.print()' style='background: green; color: white; position: fixed; top: 100px; left: 0px; padding: 10px; font-size: 18px' class='print'>طباعة الان</button>
            ${html}
            </body>
        </html>
        `)
        win.document.close()
        win.document.designMode = "on"
        },
        remove(id){
            if(confirm('متأكد من حذف المخالفة؟')){
                var g = this;
                $.post(api + '/user/students/bis/delete', {
                    jwt: this.user.jwt,
                    id: id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.getReport()
                        $("#remove___BV_modal_header_ > button").click()
                    }
                }).fail(function(){
                })
            }
        },
        removeSingle(id, number){
            var g = this;
            if(confirm('متأكد من حذف المخالفة؟')){
                $.post(api + '/user/students/bis/delete-single', {
                    jwt: this.user.jwt,
                    number: number,
                    id: id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.getReport()
                        $("#remove___BV_modal_header_ > button").click()
                    }
                }).fail(function(){
                })
            }
        },
        dayname(date){
            const valentines = new Date(date);
            const day = valentines.getDay();
            const dayNames = ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];

            return dayNames[day];
        },
        getReport(){
            var g = this;
            $.post(api + '/user/students/bis/all', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.bis = r.response
                    g.bis.forEach(function(a){
                        a.students.forEach(function(b){
                            if(!g.classrooms.includes(b.classname + ' - ' + b.classroom)){
                                g.classrooms.push(b.classname + ' - ' + b.classroom)
                            }
                        })
                    })
                    g.original_bis = JSON.parse(JSON.stringify(g.bis))
                }
            }).fail(function(){
            })
        },
        getStudents(){
            var g = this;
            $.post(api + '/user/students/list', {
                jwt: this.user.jwt,
                q: this.q,
                page: 1,
                perpage: 10000
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.students = r.response
                    if(window.location.hash && !g.q){
                        g.students.forEach(function(a){
                            if(a.number == window.location.hash.replace("#", "")){
                                g.q = a.name;
                                g.getStudents()
                            }
                        })
                    }
                }
            }).fail(function(){
                g.loading = false;
            })
        },
        done(){
            var g = this;
            if(!g.bi || g.bi == ""){
                alert("يجب اختيار المخالفة")
                return;
            }
            if(g.selected.length == 0){
                alert("برجاء اختيار الطلاب")
                return;
            }
            if(!g.method && g.send != 2 && !g.wa){
                $("#sssend").click()
                return;
            }
            if(g.wa){
                var messages = [];
                g.students.forEach(function(a){
                    if(g.selected.includes(a.number)){
                        messages.push({
                            phones: a.phones,
                            message: g.message.replace("{name}", a?.name).replace("{action}", g.action?.join(", ")).replace("{bi}", g.bi?.toString())
                        })
                    }
                })
                $("#sendmodalwaarray").val(JSON.stringify(messages))
                $("#sendmodalwatype").val("students")
                $("#sendWAModal").click()
            }
            if(g.saved){
                return;
            }
            $.post(api + '/user/students/bis/add', {
                jwt: this.user.jwt,
                send: this.send,
                actions: this.action,
                method: this.sendmethod,
                bi: this.bi,
                students: this.selected,
                level: this.level,
                message: this.message
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.saved = true;
                    if(!g.wa){
                        location.reload()
                    }
                }
            }).fail(function(){
                g.loading = false;
            })
        }
    }
}
</script>

<style>

</style>